import { useCurrentUser } from "hooks/use-current-user"

// Typeform expects snake case fields
export function useTypeformUserFields() {
  const user = useCurrentUser()

  return {
    account_id: user?.account_id || "",
    account_name: user?.account_name || "",
    account_creation_date: user?.account_created_at || "",
    user_email: user?.email || "",
    plan_id: user?.plan_id || "",
    plan_name: user?.plan_name || ""
  }
}
